var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 827.42 23.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke:#174a63;}.d,.e{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}.e{stroke:#164963;}.f{fill:#eaf0fa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    y: 11.59,
    width: 827.39,
    height: 11.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 769,
    y1: 11.59,
    x2: 826.67,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 776.04,
    y1: 15.05,
    x2: 781.67,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 721.93,
    y1: 11.59,
    x2: 761.29,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 650.16,
    y1: 11.59,
    x2: 717.06,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 476.72,
    y1: 11.59,
    x2: 646.22,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 409.9,
    y1: 11.59,
    x2: 469.4,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 402.33,
    y1: 11.59,
    x2: 405.63,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 367.48,
    y1: 11.59,
    x2: 397.32,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 208.68,
    y1: 11.59,
    x2: 364.38,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 199.6,
    y1: 11.59,
    x2: 203.06,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 161.56,
    y1: 11.59,
    x2: 194.79,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 68.84,
    y1: 11.59,
    x2: 153.33,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 11.59,
    y1: 11.59,
    x2: 59.45,
    y2: 11.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 44.81,
    y1: 15.05,
    x2: 98.68,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 185.65,
    y1: 15.05,
    x2: 301.03,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 185.65,
    y1: 15.05,
    x2: 301.03,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 358,
    y1: 15.05,
    x2: 411.87,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 443.88,
    y1: 15.05,
    x2: 488.46,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 640.64,
    y1: 15.05,
    x2: 756.5,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 416.28,
    y1: 15.05,
    x2: 419.57,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 497.68,
    y1: 15.05,
    x2: 500.97,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 632.23,
    y1: 15.05,
    x2: 635.53,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 535.94,
    y1: 15.05,
    x2: 572.64,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 318.85,
    y1: 15.05,
    x2: 343.68,
    y2: 15.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.98,3.52c3.43,4.65,1.83,11.15,2.78,8.52,.95-2.63,2.28-6.78,3.83-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.75,7.8s2.76,1.32,4.23,4.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.41,6.27c3.66,5.06,2.25,12.65,3.38,6.47l1.13-6.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M476.72,.75c-4.92,4.98-3.03,12.46-4.54,6.37l-1.51-6.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M759.86,3.56c6.6,4.87,4.06,12.17,6.09,6.22l2.03-5.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 144.47,
    y1: 15.05,
    x2: 152.77,
    y2: 15.05
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.f5c81a655683b172f677267dc4cb3905.svg";
export { ForwardRef as ReactComponent };